import { createAction } from 'actions/utils'

export const SET_DRAWER_OPENING = 'SET_DRAWER_OPENING'
export const setIsDrawerOpening = createAction(SET_DRAWER_OPENING)

export const SET_DRAWER_OPENED = 'SET_DRAWER_OPENED'
export const setIsDrawerOpened = createAction(SET_DRAWER_OPENED)

export const SET_DRAWER_CLOSING = 'SET_DRAWER_CLOSING'
export const setIsDrawerClosing = createAction(SET_DRAWER_CLOSING)

export const SET_DRAWER_CLOSED = 'SET_DRAWER_CLOSED'
export const setIsDrawerClosed = createAction(SET_DRAWER_CLOSED)

export const SET_DRAWER_VISIBLE = 'SET_DRAWER_VISIBLE'
export const setIsDrawerVisible = createAction(SET_DRAWER_VISIBLE, ['visible'])

export const SET_SHOW_DRAWER_MASK = 'SET_SHOW_DRAWER_MASK'
export const setShowDrawerMask = createAction(SET_SHOW_DRAWER_MASK, ['visible'])

export const SET_DRAWER_WIDTH = 'SET_DRAWER_WIDTH'
export const setDrawerWidth = createAction(SET_DRAWER_WIDTH, ['width'])

export const SET_DRAWER_VISIBLE_WIDTH = 'SET_DRAWER_VISIBLE_WIDTH'
export const setDrawerVisibleWidth = createAction(SET_DRAWER_VISIBLE_WIDTH, [
  'width',
])
